import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { ApplicationHistoryResponse } from "@/shared/repository/modules/application/repo";
import { SvgAttribute } from "@/shared/constants/constants";
import {
  formatFiatCurrency,
  formatCryptoCurrency,
} from "@/shared/utils/amount-helpers";
import { AdminCurrencyType } from "@/shared/repository/modules/admin/currency/enums";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    row: {
      type: <PropType<ApplicationHistoryResponse>>Object,
      required: true,
    },
  },
  computed: {
    displayedSvg(): SvgAttribute {
      return SVG;
    },

    displayedAmountFrom(): string {
      if (this.row.currency_type_from === AdminCurrencyType.fiat) {
        return formatFiatCurrency(this.row.amount);
      } else {
        return formatCryptoCurrency(this.row.amount);
      }
    },

    displayedAmountTo(): string {
      if (
        this.row.currency_type_to === AdminCurrencyType.crypto &&
        this.row.currency_type_from === AdminCurrencyType.crypto
      ) {
        return formatCryptoCurrency(this.row.transaction_volume);
      }
      if (this.row.currency_type_to === AdminCurrencyType.fiat) {
        return formatFiatCurrency(this.row.transaction_volume);
      } else {
        return formatCryptoCurrency(this.row.transaction_volume);
      }
    },

    statusTone(): string {
      const status = this.row.status;

      if (status === "completed") return "success";
      if (status === "reject" || status === "failed") return "error";
      if (status === "waiting" || status === "in_work") return "warning";

      return "pending";
    },

    statusLabel(): string {
      const labels: Record<string, string> = {
        completed: "Выполнена",
        reject: "Отклонена",
        failed: "Отклонена",
        waiting: "Ожидает оплаты",
        in_work: "В обработке",
        pending: "На проверке",
      };

      return labels[this.row.status] || "На проверке";
    },
  },
});
